import script from "./PosSidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./PosSidebar.vue?vue&type=script&setup=true&lang=js"

import "./PosSidebar.vue?vue&type=style&index=0&id=fd6a6d50&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fd6a6d50"]])

export default __exports__